import { type FC } from 'react'
import classNames from 'classnames'
import { type BusinessListingProps } from './BusinessListing.interface'
import styles from './BusinessListing.module.scss'
import { BusinessListingFilters } from '~/components/BusinessListingFilters/BusinessListingFilters'
import { BusinessCard } from '~/components/Cards/BusinessCard/BusinessCard'
import { Footer } from '~/components/Footer/Footer'

interface BusinessListingComponentProps extends BusinessListingProps {
  containerRef: React.RefObject<HTMLDivElement>;
}

export const BusinessListing: FC<BusinessListingComponentProps> = ({
  filters,
  businesses,
  setBusinessId,
  activeBusinessId,
  hoveredBusinessId,
  setHoveredBusinessId,
  setListView,
  listView,
  footer,
  containerRef
}) => {
  const { type, total, categories } = filters

  const title = `Showing ${total} result(s) for independent ${type.name}${categories.length > 1 ? ',' : ''} ${categories.filter((category) => category).map((category, index, arr) => {
    const categoryName = category.name
    if (index === arr.length - 1 && arr.length >= 1) {
      return `and ${categoryName}`
    }
      return categoryName
  }).join(', ')} businesses, in Witney.`

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.filters}>
        <BusinessListingFilters
          total={filters.total}
          sortBy={filters.sortBy}
          type={filters.type}
          categories={filters.categories}
          setListView={setListView}
          listView={listView}
        />
      </div>
      <div className={classNames(
        styles.businesses,
        !listView ? '' : styles['map-view'],
        activeBusinessId ? styles['map-view'] : ''
      )}
      >
        <h1 className={styles.title}>{title}</h1>
        <section className={styles['businesses-list']}>
          {businesses.map((item, index) => (
            <BusinessCard
              key={item.id}
              id={item.id}
              index={index + 1}
              title={item.title}
              slug={item.slug}
              url={item.url}
              description={item.shortDescription}
              image={item.image}
              type={item.type}
              categories={item.categories}
              setBusinessId={setBusinessId}
              setHoveredBusinessId={setHoveredBusinessId}
              active={activeBusinessId === item.id}
              hovered={hoveredBusinessId === item.id}
              // imageLazy={index + 1 >= 5}
              priorityImage={index === 0}
            />
          ))}
        </section>
        {footer && (
          <Footer
            copyrightText={footer.copyrightText}
            footerLinks={footer.footerLinks}
            siteByLabel={footer.siteByLabel}
            siteByLink={footer.siteByLink}
            noContainer
          />
        )}
      </div>
    </div>
  )
}
